import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getAdminAccountDetails = () =>
  axiosInstance.get(`${ADMIN_API_URL}/admin-profile`, {
    headers: authHeaders(),
  });

export const updateAdminAccountRequest = (payload) =>
  axiosInstance.post(`${ADMIN_API_URL}/update-account`, payload, {
    headers: authHeaders(),
  });
